export default class PromiseLock {
  private busy = false;

  /**
   * Attempt to acquire the lock. Returns true if the lock was free and is now
   * held by the caller, or false if the lock is already held elsewhere.
   */
  tryAcquire(): boolean {
    if (this.busy) {
      return false;
    }
    this.busy = true;
    return true;
  }

  /** Release the lock so that another caller can acquire it. */
  release() {
    this.busy = false;
  }

  /** Syntactic sugar so callers can check if the lock is currently held. */
  get locked(): boolean {
    return this.busy;
  }
}
